import React from 'react';
import { Page } from '../types';

interface FooterProps {
  setPage?: (page: Page) => void;
}

const Footer: React.FC<FooterProps> = ({ setPage }) => {
  const handlePageChange = (page: Page) => {
    if (setPage) {
      setPage(page);
      window.scrollTo(0, 0);
    }
  };

  return (
    <footer className="bg-slate-900 text-slate-300 pt-32 pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-4 gap-12 mb-20">
          <div className="col-span-1 lg:col-span-1">
            <div className="flex items-center mb-8">
              <img 
                src="https://res.cloudinary.com/dohuj4mx9/image/upload/v1769023542/fintrack_logo_unique_v1-removebg-preview_oc4bqx.png" 
                alt="FinTrack Logo" 
                className="w-36 h-36 sm:w-44 sm:h-44 object-contain cursor-pointer"
                onClick={() => handlePageChange('home')}
              />
            </div>
            <p className="text-slate-400 mb-10 leading-relaxed text-lg">
              Professional accounting and business registration services tailored for the next generation of Nigerian startups.
            </p>
            <div className="flex gap-5">
              {['facebook', 'alternate_email', 'link', 'linked_camera'].map((icon, i) => (
                <a key={i} href="#" className="w-12 h-12 rounded-2xl bg-slate-800 flex items-center justify-center hover:bg-primary transition-all hover:scale-110 shadow-lg">
                  <span className="material-symbols-rounded text-lg">{icon}</span>
                </a>
              ))}
            </div>
          </div>
          
          <div className="lg:pl-10">
            <h4 className="text-white font-bold text-xl mb-8">Services</h4>
            <ul className="space-y-5">
              <li><button onClick={() => handlePageChange('cac-registration')} className="hover:text-primary transition-colors text-lg text-left">CAC Registration</button></li>
              <li><button onClick={() => handlePageChange('tax-compliance')} className="hover:text-primary transition-colors text-lg text-left">Tax Filing (TIN/VAT)</button></li>
              <li><button onClick={() => handlePageChange('bookkeeping')} className="hover:text-primary transition-colors text-lg text-left">Monthly Bookkeeping</button></li>
              <li><button onClick={() => handlePageChange('post-inc')} className="hover:text-primary transition-colors text-lg text-left">Annual Returns</button></li>
              <li><button onClick={() => handlePageChange('advisory')} className="hover:text-primary transition-colors text-lg text-left">Business Advisory</button></li>
            </ul>
          </div>
          
          <div className="lg:pl-10">
            <h4 className="text-white font-bold text-xl mb-8">Resources</h4>
            <ul className="space-y-5">
              <li><button onClick={() => handlePageChange('resources')} className="hover:text-primary transition-colors text-lg text-left">Knowledge Base</button></li>
              <li><button onClick={() => handlePageChange('how-it-works')} className="hover:text-primary transition-colors text-lg text-left">How It Works</button></li>
              <li><button onClick={() => handlePageChange('about')} className="hover:text-primary transition-colors text-lg text-left">About Us</button></li>
              <li><button onClick={() => handlePageChange('contact')} className="hover:text-primary transition-colors text-lg text-left">Partner Program</button></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-white font-bold text-xl mb-8">Contact</h4>
            <ul className="space-y-6">
              <li className="flex items-start gap-4">
                <span className="material-symbols-rounded text-primary text-2xl mt-1">location_on</span>
                <span className="text-lg">Lekki Phase 1, Lagos, Nigeria.</span>
              </li>
              <li className="flex items-start gap-4">
                <span className="material-symbols-rounded text-primary text-2xl mt-1">mail</span>
                <span className="text-lg truncate">finrackbizsolutions@gmail.com</span>
              </li>
              <li className="flex items-start gap-4">
                <span className="material-symbols-rounded text-primary text-2xl mt-1">call</span>
                <span className="text-lg">+2347089903452</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="pt-12 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-8">
          <p className="text-sm text-slate-500 font-medium">© 2024-2026 FinTrack Compliance Services. All rights reserved.</p>
          <div className="flex gap-10 text-sm text-slate-500 font-medium">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;